'use client';

import { useState } from 'react';

import { Box, Container, Stack, Tabs } from '@mui/material';

import AccordionMenu from '@/components/AccordionMenu';
import PillTab from '@/components/PillTab';
import { Accordion } from '@/types/accordion.type';
import { FAQGroup } from '@/types/faq.type';

import styles from './FAQSection.module.scss';

interface FAQSectionProps {
  faqGroups: FAQGroup[];
  allLabel?: string;
}

const FAQSection = ({ faqGroups, allLabel = 'All' }: FAQSectionProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const allQuestions: Accordion[] = faqGroups.flatMap(group => group.questions);

  const getActiveQuestions = (): Accordion[] => {
    if (activeTab === 0) {
      return allQuestions;
    }

    return faqGroups[activeTab - 1]?.questions || [];
  };

  return (
    <Box component="section" className={styles.section}>
      <Container maxWidth="xl" className={styles.container}>
        <Stack spacing={5}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            className={styles.tabs}
            slotProps={{
              indicator: { style: { display: 'none' } },
            }}
          >
            <PillTab label={allLabel} value={0} />
            {faqGroups.map((group, index) => (
              <PillTab key={group.title} label={group.title} value={index + 1} />
            ))}
          </Tabs>
          <AccordionMenu accordionList={getActiveQuestions()} />
        </Stack>
      </Container>
    </Box>
  );
};

export default FAQSection;
